// extracted by mini-css-extract-plugin
module.exports = {"BooksLoading":"BooksLoading_BooksLoading__1wvr0","BooksLoading_Icon":"BooksLoading_BooksLoading_Icon__37yx1"};